import {
  SNACKBAR_HIDE_MESSAGE,
  SNACKBAR_SHOW_MESSAGE,
} from '../action-types/snackbar-types';

const initialState = {
  message: '',
  show: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SNACKBAR_SHOW_MESSAGE:
      return {
        ...state,
        message: action.payload,
        show: true,
      };
    case SNACKBAR_HIDE_MESSAGE:
      return {
        ...state,
        message: '',
        show: false,
      };
    default:
      return state;
  }
}
